import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  FLAG_GETTING_ROUTES,
  GET_ROUTES,
  CLEAR_ROUTES,
  FLAG_ROUTE_ACTIVITY,
  GET_ROUTE,
  CLEAR_ROUTE,
} from '../types';
import { COMPANY_ROUTE_ENDPOINT, ROUTE_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_PATCH_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { ROUTE_PATH } from '../../config/paths';

const flagGettingRoutes = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_ROUTES,
  });

const flagRouteActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ROUTE_ACTIVITY,
    payload: flag,
  });

const getRoutes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingRoutes(true));

    const query = tableFilters;

    const url = `${ROUTE_ENDPOINT}?${QueryString.stringify(query)}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);

    await isErrorResponse(response, null, dispatch);

    const routes = await response.json();

    dispatch({
      type: GET_ROUTES,
      payload: routes,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingRoutes(false));
  }
};

const getRoute =
  async ({ routeId }) =>
    async (dispatch) => {
      try {
        dispatch(flagRouteActivity(true));
        const url = `${ROUTE_ENDPOINT}/${routeId}`;
        const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
        await isErrorResponse(response, null, dispatch);
        const circuitGroup = await response.json();
        dispatch({
          type: GET_ROUTE,
          payload: circuitGroup,
        });
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagRouteActivity(false));
      }
    };

const getCompanyRoutes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingRoutes(true));

    const query = tableFilters;

    const url = `${COMPANY_ROUTE_ENDPOINT}?${QueryString.stringify(query)}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);

    await isErrorResponse(response, null, dispatch);

    const routes = await response.json();

    dispatch({
      type: GET_ROUTES,
      payload: routes,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingRoutes(false));
  }
};

const postRoute =
  async ({
    name,
    description,
    isOneWay,
    isMaciva,
    routeSegmentList,
    hotZone,
    coldZone,
    steepRoute,
    flatRoute,
    lengthType,
    isPostDepartSalesAllowed,
    isNorthChico,
    active
  }) =>
    async (dispatch) => {
      try {
        dispatch(flagRouteActivity(true));
        const payload = {
          name,
          description,
          isOneWay,
          isMaciva,
          routeSegmentList,
          hotZone,
          coldZone,
          steepRoute,
          flatRoute,
          lengthType,
          isPostDepartSalesAllowed,
          isNorthChico,
          active
        };
        const url = ROUTE_ENDPOINT;
        const promise = await fetch(url, {
          ...DEFAULT_POST_CONFIG,
          body: JSON.stringify(payload),
        });
        await isErrorResponse(promise, null, dispatch);
        const response = await promise.json();
        dispatch(push(`${ROUTE_PATH}/${response.id}`));
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagRouteActivity(false));
      }
    };

const putRoute = (routeId, routeData) => async (dispatch) => {
  try {
    dispatch(flagRouteActivity(true));

    const payload = {
      ...routeData,
      id: routeId,
    };

    const url = `${ROUTE_ENDPOINT}/${routeId}`;
    const promise = await fetch(url, {
      ...DEFAULT_PUT_CONFIG,
      body: JSON.stringify(payload),
    });

    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();

    dispatch(push(`${ROUTE_PATH}/${response.id}`));
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagRouteActivity(false));
  }
};

const patchRouteActive =
  async ({routeId}) =>
  async (dispatch) => {
    try {
      dispatch(flagRouteActivity(true));
      const url = `${ROUTE_ENDPOINT}/${routeId}/active`;
      const promise = await fetch(url, {
        ...DEFAULT_PATCH_CONFIG
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(ROUTE_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagRouteActivity(false));
    }
  };

const deleteRoute =
  async ({ routeId }) =>
    async (dispatch) => {
      try {
        dispatch(flagRouteActivity(true));
        const url = `${ROUTE_ENDPOINT}/${routeId}`;
        const promise = await fetch(url, {
          ...DEFAULT_DELETE_CONFIG,
        });
        await isErrorResponse(promise, null, dispatch);
        await promise.json();
        dispatch(push(ROUTE_PATH));
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagRouteActivity(false));
      }
    };

const clearRoutes = () => (dispatch) =>
  dispatch({
    type: CLEAR_ROUTES,
  });

const clearRoute = () => (dispatch) =>
  dispatch({
    type: CLEAR_ROUTE,
  });

export {
  flagGettingRoutes,
  getRoutes,
  clearRoutes,
  getRoute,
  getCompanyRoutes,
  clearRoute,
  deleteRoute,
  postRoute,
  putRoute,
  patchRouteActive
};
